import { Filter } from "@p0security/shared/types/policy/types";
import { Popover, Spacing, Typography } from "@p0security/ui";
import stringify from "json-stable-stringify";
import pluralize from "pluralize";
import { useMemo } from "react";
import { stopPropagation } from "utils/javascript";

import { StyledResourceFilterCount } from "../../styles";
import { ResourceFilterPreview } from "./ResourceFilterPreview";

type Props = {
  resourceFilters: {
    filter: Filter;
    filterType: string;
  }[];
};

export const ResourceFilterCount: React.FC<Props> = ({ resourceFilters }) => {
  const filterList = useMemo(
    () => (
      <Spacing asChild mb={0}>
        <ul style={{ maxWidth: 350, paddingLeft: "1em" }}>
          {resourceFilters.map((filter) => {
            return (
              <li key={stringify(filter)}>
                <ResourceFilterPreview
                  filter={filter.filter}
                  filterType={filter.filterType}
                />
              </li>
            );
          })}
        </ul>
      </Spacing>
    ),
    [resourceFilters]
  );

  if (resourceFilters.length === 1) {
    const firstFilter = resourceFilters[0]!;
    return (
      <Popover content={filterList} trigger="hover">
        <div
          className="filters max-w-xs overflow-hidden text-ellipsis whitespace-nowrap"
          onClick={stopPropagation}
        >
          <Typography.Text type="secondary" className="text-xs">
            <ResourceFilterPreview
              filter={firstFilter.filter}
              filterType={firstFilter.filterType}
              inline
              secondary
            />
          </Typography.Text>
        </div>
      </Popover>
    );
  }

  return (
    <Popover content={filterList} trigger="hover">
      <StyledResourceFilterCount
        className="filters cursor-pointer"
        onClick={stopPropagation}
      >
        <Typography.Paragraph type="secondary" className="text">
          {`${resourceFilters.length} ${pluralize(
            "filter",
            resourceFilters.length
          )}`}
        </Typography.Paragraph>
      </StyledResourceFilterCount>
    </Popover>
  );
};
